
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'

import UnassignedJobsCard from '../components/UnassignedJobsCard.vue'
import GoToJobCard from '../components/GoToJobCard.vue'
import ActiveJobsCard from '../components/ActiveJobsCard.vue'
import ActiveIssuesCard from '../components/ActiveIssuesCard.vue'
import CompletedJobsCard from '../components/CompletedJobsCard.vue'
import JobChart from '../components/JobChart.vue'
import RevenueChart from '../components/RevenueChart.vue'
import { centDisplay } from '@/domains/global/functions/util'

type StatConfig = {
  days: number;
}

const jobFinishedEvents = ['job:completed', 'job:abandoned']
const jobUpdatedEvents = ['job:claimed', 'job:surrendered', 'job:started', 'job:review-required', 'job:review-completed', 'job:action-required', 'job:action-completed', 'job:completed', 'job:abandoned']
const jobClaimEvents = ['job:submitted', 'job:claimed', 'job:surrendered']
const disputeMajorEvents = ['dispute:submitted', 'dispute:resolved', 'dispute:adjudicated', 'dispute:withdrawn']
const disputeUpdatedEvents = ['dispute:updated', 'dispute:adjudication-requested', 'dispute:submitted', 'dispute:resolved', 'dispute:adjudicated', 'dispute:withdrawn']
const invoiceEvents = ['customer-invoice:refunded', 'customer-invoice:disbursed-refunded']

@Component({
  components: { UnassignedJobsCard, ActiveJobsCard, ActiveIssuesCard, CompletedJobsCard, JobChart, RevenueChart, GoToJobCard }
})
export default class DashboardPage extends Vue {
  private totalJobCount = 0

  private totalRevenue = 0

  private config: StatConfig = { days: 0 }

  get jobChart () {
    return this.$refs.jobChart as JobChart
  }

  get revenueChart () {
    return this.$refs.revenueChart as RevenueChart
  }

  get unassignedJobsList () {
    return this.$refs.unassignedJobsList as UnassignedJobsCard
  }

  get activeJobsList () {
    return this.$refs.activeJobsList as ActiveJobsCard
  }

  get activeIssuesList () {
    return this.$refs.activeIssuesList as ActiveIssuesCard
  }

  get completedJobsList () {
    return this.$refs.completedJobsList as CompletedJobsCard
  }

  mounted () {
    this.getStatConfig()
    this.$socket().on('dashboard:update', this.handleUpdate)
  }

  beforeDestroy () {
    this.$socket().off('dashboard:update', this.handleUpdate)
  }

  private async getStatConfig() {
    const response = await axios.get<StatConfig>('/stats/config')
    this.config = response.data
  }

  handleUpdate (data: { event: string }) {
    if (jobFinishedEvents.includes(data.event)) {
      this.completedJobsList.refresh()
      this.jobChart.getCompletedJobsStatsData()
      this.revenueChart.getRevenueStatsData()
    }

    if (jobUpdatedEvents.includes(data.event) || disputeMajorEvents.includes(data.event)) {
      this.activeJobsList.refresh()
    }

    if (jobClaimEvents.includes(data.event)) {
      this.unassignedJobsList.refresh()
    }

    if (disputeUpdatedEvents.includes(data.event)) {
      this.activeIssuesList.refresh()
    }

    if (invoiceEvents.includes(data.event)) {
      this.revenueChart.getRevenueStatsData()
    }
  }
}
